import { PRODUCT_TO_TIER } from "@/constants/stripeTiers";

export type ResolvedTier = "trial" | "starter" | "pro" | null;

export interface SubscriptionState {
  subscribed: boolean;
  status: string | null;
  productId: string | null;
  subscriptionTrialEnd: string | null;
  gracePeriodEnd: string | null;
}

const productToPaidTier = (productId: string | null): ResolvedTier => {
  if (!productId) return null;
  const mapped = PRODUCT_TO_TIER[productId];
  if (mapped === "starter" || mapped === "pro") return mapped;
  return null;
};

export function resolveTier(
  state: SubscriptionState,
  now: Date = new Date()
): ResolvedTier {
  if (state.subscriptionTrialEnd) {
    const trialEnd = new Date(state.subscriptionTrialEnd);
    if (!Number.isNaN(trialEnd.getTime()) && trialEnd > now) {
      return "trial";
    }
  }

  if (state.status === "past_due") {
    if (!state.gracePeriodEnd) return null;
    const graceEnd = new Date(state.gracePeriodEnd);
    if (Number.isNaN(graceEnd.getTime()) || graceEnd <= now) return null;
    return productToPaidTier(state.productId);
  }

  if (state.status === "active" && state.subscribed) {
    return productToPaidTier(state.productId);
  }

  return null;
}
